// extracted by mini-css-extract-plugin
export default {"linkContainer":"AKL7Y","link":"cPp_d","icon":"olqG1"};